import { AutocompleteItem, Card, CardBody, Button, Input, Select, SelectItem, Autocomplete, Checkbox } from "@heroui/react"
import { ErrorCard, LoadingCard, MainContainer } from "../../components"
import { useEffect, useMemo, useRef, useState } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import * as XLSX from 'xlsx';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faList, faSave } from "@fortawesome/free-solid-svg-icons";
import { apiRoute, ENUM_MOD_NAME, getModMandatory, linksUrl, URIEncrypt } from "../../constants/enum";
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import { selectClasses } from "@mui/material";

const ImportAccount = () => {
    const { compCode, } = useSelector((state) => state.company)
    const { user } = useSelector((state) => state.auth);
    const [excelData, setExcelData] = useState([])
    const [selAcType, setSelAcType] = useState("")
    const [selUnderGroup, setSelUnderGroup] = useState("")
    const [duplicateRows, setDuplicateRows] = useState([])

    const navi = useNavigate();
    const fileInputRef = useRef()

    const handleChange = (e) => {
        const { value, name, } = e.target
        setFormData({ ...formData, [name]: value })
    }

    const handleAutoCompleteChange = (value, name) => {



    }

    // const handleDateChange = (newValue) => {

    //     const rdate = newValue != '' && newValue != 'Invalid Date' ? dayjs(newValue).format("YYYY-MM-DD") : null

    //     setFormData((prev) => {
    //         return {
    //             ...prev,
    //             "rDate": rdate,
    //         };
    //     });
    //     if (rdate && rdate != "Invalid Date") {
    //         funMktLotNo(rdate)
    //     }
    // }

    // const handleDateBlur = (e, name) => {
    //     const input = e.target.value.trim();   // "DD/MM/YYYY"

    //     if (!input) return;

    //     // Parse typed date strictly as DD/MM/YYYY
    //     const parsed = dayjs(input, "DD/MM/YYYY", true);

    //     // ❌ Invalid format or wrong date typed
    //     if (!parsed.isValid()) {
    //         toast.error("Invalid date format. Use DD/MM/YYYY", {
    //             position: "top-center",
    //             className: "toast-error"
    //         });
    //         return;
    //     }

    //     const formatted = parsed.format("YYYY-MM-DD");


    //     setFormData(prev => {
    //         const updated = { ...prev, [name]: formatted };
    //         return updated;
    //     });

    // };
    const { isError: isErrorMastType, data: masterData = [] } = useFetchWithBody({
        url: apiRoute.account.masterTypeProcess,
        queryKey: "masterTypeProcess",
        inputData: {
            compcode: compCode.join(","),
        }
    })



    const [formData, setFormData] = useState({

    })
    // const { data: excelTempData, mutate: filterXlTemplate } = usePost({
    //     url: apiRoute.stockEntry.getExcelTemplate,
    //     queryKey: "funExcelTemplateStock",

    // })
    const [excelTempData, setExcelTempData] = useState([
        { xl_col_name: "A/C Id", xl_col_no: 1, tb_col_name: "ac_id" },
        { xl_col_name: "A/c. Description", xl_col_no: 2, tb_col_name: "ac_desc" },
        { xl_col_name: "Under Group", xl_col_no: 3, tb_col_name: "grp_code" },
        { xl_col_name: "Address 1", xl_col_no: 4, tb_col_name: "add_1" },
        { xl_col_name: "Address 2", xl_col_no: 5, tb_col_name: "add_2" },
        { xl_col_name: "Address 3", xl_col_no: 6, tb_col_name: "add_3" },
        { xl_col_name: "Address 4", xl_col_no: 7, tb_col_name: "add_4" },
        { xl_col_name: "GST No", xl_col_no: 8, tb_col_name: "gst_no" },
        { xl_col_name: "Pan No", xl_col_no: 9, tb_col_name: "it_no" },
        { xl_col_name: "Contact No", xl_col_no: 12, tb_col_name: "contactno1" },
        { xl_col_name: "EmailId", xl_col_no: 13, tb_col_name: "email_id" },
    ])
    const { isPending, isError, mutate: funAdd } = usePost({
        url: apiRoute.account.importAccounts,
        queryKey: "funAddAccount",
        onSuccessTasks: (data) => {
            toast.success("Accounts Imported ", {
                position: "top-center"
            })
        }

    })
    // useEffect(() => {
    //     if (modSetting && modSetting.length > 0) {

    //     }

    // }, [modSetting])

    const columnMapping = useMemo(() => {
        const d = excelTempData.map((row) => {
            return {
                [row.xl_col_no]: row.tb_col_name
            }
        })

        const flipped = d.reduce((acc, obj) => {
            const [key, value] = Object.entries(obj)[0];
            acc[value] = key;
            return acc;
        }, {});
        return flipped
    }, [excelTempData])
    console.log(excelData)

    const grpDescMap = new Map(
        (masterData?.itemUnGroup ?? []).map(item => [
            item.GRP_DESC.toLowerCase(),
            String(item.GRP_CODE)
        ])
    );

    const acTypeMap = new Map(
        (masterData?.itemAcType ?? []).map(item => [
            String(item.defgrpcode),
            item.actypeid
        ])
    );
    const splitUniqueAndDuplicate = (data) => {
        const map = new Map();
        const duplicates = [];
        const unique = [];

        data.forEach((item, index) => {
            const key = item.ac_desc?.trim().toLowerCase();

            if (!key) return; // skip empty

            if (map.has(key)) {
                duplicates.push({ ...item, rowIndex: index + 1 });
            } else {
                map.set(key, true);
                unique.push(item);
            }
        });

        return { unique, duplicates };
    };


    // console.log(excelData,"xl",)
    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = (event) => {
            console.log("eve");

            const binaryStr = event.target.result;
            const workbook = XLSX.read(binaryStr, { type: 'binary' });
            const worksheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[worksheetName];

            const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            //console.log(rows, "fg");

            const headers = rows[0];
            const dataRows = rows.slice(1);

            if (headers.length === Object.keys(columnMapping).length) {
                const mapped = dataRows
                    .filter(row => row.length)
                    .map(row => {
                        const finalResult = {};

                        Object.entries(columnMapping).forEach(([key, value]) => {
                            finalResult[key] = row[Number(value) - 1] ?? null;
                        });

                        return finalResult;
                    });
                if (mapped?.length) {
                    const { unique, duplicates } = splitUniqueAndDuplicate(mapped);
                    setDuplicateRows(duplicates)
                    const newData = unique.map(ele => {
                        const grpKey = ele.grp_code?.toLowerCase();
                        const selGrpCode = grpDescMap.get(grpKey) || "";
                        const selAcType = acTypeMap.get(selGrpCode) || "";

                        return {
                            ...ele,
                            grp_code: selUnderGroup != "" && selUnderGroup != null ? selUnderGroup : selGrpCode,
                            ac_type:  selAcType != "" && selAcType != null ? selAcType : selAcType
                        };
                    });

                    setExcelData(newData);
                }


            } else {
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
                toast.error(
                    "Excel File No of Columns Mis-Match With Format",
                    { position: "top-center", className: "toast-error" }
                );
            }
        };

        // ✅ THIS MUST BE OUTSIDE onload
        reader.readAsBinaryString(file);
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        funAdd({
            data: {
                comp_code: compCode.join(","),
                excel_data: excelData,
                user_id: user.username,
                rec_status: 2
            }
        })

    }

    const handleDownloadExcel = () => {
        // File: ExportExcel.js
        // Define headersif()

        const data = [...excelTempData];

        const sortedData = data.sort((a, b) => Number(a.xl_col_no) - Number(b.xl_col_no));

        const headers = sortedData.map(ele => ele.xl_col_name)
        //if (headers && headers.length > 0) {
        //  Create a worksheet with headers only
        const ws = XLSX.utils.aoa_to_sheet([headers]);

        // Create a new workbook and append the worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        // Generate Excel file buffer
        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });

        // Trigger download with FileSaver
        const blob = new Blob([wbout], { type: "application/octet-stream" });
        saveAs(blob, "ACCImport.xlsx");


    }
    const handleClickPrev = () => {
        navi( linksUrl.master.account.accountMaster)
    }
    if (isError) {
        return <ErrorCard />
    }
    if (isPending) {
        return <LoadingCard />
    }
    return (
        <MainContainer pageName={"Import Accounts"}
            breadcrumbs={["Master", "Account Import"]} 
            prevPage={{
                    show: true,
                    onClick: handleClickPrev,
                }}
            >
           
            <Card>
                <form onSubmit={handleSubmit} autoComplete='off'>
                    <CardBody>
                        <div className="flex gap-4 align-top items-baseline mb-2">
                            <Autocomplete
                                size="sm"
                                name={"acType"}
                                label={"Ac Type"}
                                eventResizeFeature={true}
                                selectionMode="single"
                                showScrollIndicators={true}
                                //labelPlacement={"outside"}
                                placeholder={""}
                               // isRequired
                                color="success"
                                className="max-w-23 font-semibold"
                                classNames={{
                                    label: "font-semibold",
                                }}
                                isClearable={false}
                                isVirtualized
                                // readonly={isNewEntry ? false : true}
                                defaultItems={
                                    masterData?.itemAcType ?? []
                                }
                                onSelectionChange={setSelAcType}
                                selectedKey={selAcType}
                            >
                                {(list) => (
                                    <AutocompleteItem

                                        key={list.actypeid}
                                    >
                                        {list.actypename}
                                    </AutocompleteItem>
                                )}
                            </Autocomplete>

                            <Autocomplete
                                size="sm"
                                name={"acType"}
                                label={"Under Group"}
                                eventResizeFeature={true}
                                selectionMode="single"
                                showScrollIndicators={true}
                                //labelPlacement={"outside"}
                                placeholder={""}

                                color="success"
                                className="max-w-23 font-semibold"
                                classNames={{
                                    label: "font-semibold",
                                }}
                                isClearable={false}
                                isVirtualized
                                // readonly={isNewEntry ? false : true}
                                defaultItems={
                                    masterData?.itemUnGroup ?? []
                                }
                                onSelectionChange={setSelUnderGroup}
                                //                                                            color={item.id == formField.debitAcId ? "success" : item.id == formField.creditAcId ? "primary" : ""}
                                //onChange={handleFormSelectionChange}
                                selectedKey={selUnderGroup}
                            >
                                {(list) => (
                                    <AutocompleteItem

                                        key={list.GRP_CODE}
                                    >
                                        {list.GRP_DESC}
                                    </AutocompleteItem>
                                )}
                            </Autocomplete>
                        </div>
                        <div className="flex gap-4 align-top items-center mb-2">
                            <Input type="file" ref={fileInputRef} color="danger" size="md" variant="flat"
                                isRequired
                                classNames={{ label: "text-lg text-slate-700 font-semibold" }}
                                label="Source File" accept=".xlsx, .xls" onChange={handleFileUpload} ></Input>
                            <Button
                                color="success"
                                size="sm"
                                variant="shadow"
                                onPress={handleDownloadExcel}
                                startContent={<FontAwesomeIcon icon={faDownload} />}
                            >
                                Excel Format   </Button>

                        </div>
                        <div className="flex  justify-around gap-4 align-top items-center mb-2">

                            <Button
                                color="primary"
                                type="submit"
                                size="sm"
                                variant="shadow"
                                isLoading={isPending}
                                startContent={<FontAwesomeIcon icon={faSave} />}
                            >
                                Submit                            </Button>
                        </div>
                        <div>
                            {excelData && excelData.length > 0 ? <h2 className="text-red-600 mt-3 font-semibold  p-2 bg-gray-50"> Total No Of Accounts To Add: {excelData.length} </h2> : ""}
                        </div>
                        <div>
                            {duplicateRows.length > 0 && (
                                <>
                                    <h4 style={{ color: 'red' }}>
                                        Duplicate Account Descriptions ({duplicateRows.length})
                                    </h4>

                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Row No</th>
                                                <th>Account Description</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {duplicateRows.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.rowIndex}</td>
                                                    <td>{item.ac_desc}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </>
                            )}

                        </div>
                    </CardBody>
                </form>
            </Card>
        </MainContainer>
    )
}
export default ImportAccount